
function parseDailyStatementData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseMonthlyStatementData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseTransactionHistoryData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseLastStatementsData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseMonthStatementData(data) {
  
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parsePdfListsData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parsePdfData(data) {
  return{
    data : JSON.stringify(data.result),
  }
}

function parseAdviceItems(data) {
 if((!data) || data.length==0){
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseTransactionHistoryForEdelivery(data) {
  if((!data) || data.length==0){
     return null;
   }
   else {
     return JSON.stringify(data);
   }
 }

function serviceFactory({ api }) {
  const getDailyStatementsData = ({portfolioId, startDate, endDate, outputType, metaData}) =>
    api
    .getDailyStatementsData(portfolioId, startDate, endDate, outputType, metaData)
    .then(parseDailyStatementData);    
  const getMonthlyStatementsData = ({portfolioId, startDate, endDate, outputType, metaData}) =>
    api
    .getMonthlyStatementsData(portfolioId, startDate, endDate, outputType, metaData)
    .then(parseMonthlyStatementData);

  const getTransactionHistoryData = ({portfolioId,startDate, endDate, metaData}) =>
    api
    .getTransactionHistoryData(portfolioId,startDate, endDate, metaData)
    .then(parseTransactionHistoryData);

  const getLastStatementsData = ({portfolioId, metaData}) =>
    api
    .getLastStatementsData(portfolioId, metaData)
    .then(parseLastStatementsData);

  const getMonthStatement = ({portfolioId, startDate, endDate, outputType, metaData}) =>
    api
    .getMonthStatement(portfolioId,startDate, endDate, outputType, metaData)
    .then(parseMonthStatementData);

  const getPdfLists = ({portfolioId, startDate, endDate, outputType, metaData}) =>
    api
    .getPdfLists(portfolioId,startDate, endDate, outputType, metaData)
    .then(parsePdfListsData);

  const getPdfStatement = ({ accountId, docId, metaData}) =>
    api
    .getPdfStatement(accountId, docId, metaData)
    .then(parsePdfData);

  const getTransactionAdvices = (portfolioId, tradeNo,metaData) =>
    api.getTransactionAdvices(portfolioId, tradeNo,metaData)
      .then(parseAdviceItems);

  const getTransactionHistoryDataForEdeliveryApp = ({portfolioId,startDate, endDate, metaData}) =>
    api.getTransactionHistoryDataForEdeliveryApp(portfolioId,startDate, endDate, metaData)
      .then(parseTransactionHistoryForEdelivery);

  const getTransactionHistoryDataForEdelivery = ({portfolioId, startDate, endDate, metaData, channel}) =>
    api.getTransactionHistoryDataForEdelivery(portfolioId,startDate, endDate, metaData, channel)
      .then(parseTransactionHistoryForEdelivery);

    return {
      getDailyStatementsData,
      getMonthlyStatementsData,
      getTransactionHistoryData,
      getLastStatementsData,
      getMonthStatement,
      getPdfLists,
      getPdfStatement,
      getTransactionAdvices,
      getTransactionHistoryDataForEdeliveryApp,
      getTransactionHistoryDataForEdelivery,
    }
}

module.exports = serviceFactory;
